export const msToSec = (ms: number): number => ms / 1000;
